"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhooksApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class WebhooksApi extends runtime.BaseAPI {
    /**
     * Incoming Araas Room events, which tell us when Rooms have been created, ended, etc.
     * Araas Room Event Ingress
     */
    araasRoomEventIngressRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling araasRoomEventIngress.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/araas/rooms/{room_id}`.replace(`{${"room_id"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming Araas Room events, which tell us when Rooms have been created, ended, etc.
     * Araas Room Event Ingress
     */
    araasRoomEventIngress(roomId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.araasRoomEventIngressRaw({ roomId: roomId, body: body });
        });
    }
    /**
     * Create a new webhook signing key, which will be used to generate webhook signature headers
     * Create Signing Key
     */
    createSigningKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling createSigningKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}/signing-keys`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateSigningKeyRequestToJSON)(requestParameters.streemApiCreateSigningKeyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateSigningKeyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new webhook signing key, which will be used to generate webhook signature headers
     * Create Signing Key
     */
    createSigningKey(webhookSid, streemApiCreateSigningKeyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createSigningKeyRaw({ webhookSid: webhookSid, streemApiCreateSigningKeyRequest: streemApiCreateSigningKeyRequest });
            return yield response.value();
        });
    }
    /**
     * Create a new webhook, which will be notified of events that occur in the system
     * Create Webhook
     */
    createWebhookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiCreateWebhookRequestToJSON)(requestParameters.streemApiCreateWebhookRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiCreateWebhookResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Create a new webhook, which will be notified of events that occur in the system
     * Create Webhook
     */
    createWebhook(streemApiCreateWebhookRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createWebhookRaw({ streemApiCreateWebhookRequest: streemApiCreateWebhookRequest });
            return yield response.value();
        });
    }
    /**
     * Delete this signing key for the given webhook
     * Delete Signing Key
     */
    deleteSigningKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling deleteSigningKey.');
            }
            if (requestParameters.signingKeySid === null || requestParameters.signingKeySid === undefined) {
                throw new runtime.RequiredError('signingKeySid', 'Required parameter requestParameters.signingKeySid was null or undefined when calling deleteSigningKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}/signing-keys/{signing_key_sid}`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))).replace(`{${"signing_key_sid"}}`, encodeURIComponent(String(requestParameters.signingKeySid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete this signing key for the given webhook
     * Delete Signing Key
     */
    deleteSigningKey(webhookSid, signingKeySid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteSigningKeyRaw({ webhookSid: webhookSid, signingKeySid: signingKeySid });
        });
    }
    /**
     * Delete this webhook
     * Delete Webhook
     */
    deleteWebhookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling deleteWebhook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete this webhook
     * Delete Webhook
     */
    deleteWebhook(webhookSid) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteWebhookRaw({ webhookSid: webhookSid });
        });
    }
    /**
     * Incoming FusionAuth events, informing us when users login, are created, etc.
     * FusionAuth Ingress
     */
    fusionAuthIngressRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/fusion-auth`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming FusionAuth events, informing us when users login, are created, etc.
     * FusionAuth Ingress
     */
    fusionAuthIngress(body) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fusionAuthIngressRaw({ body: body });
        });
    }
    /**
     * Retrieve a signing key by id, for this webhook
     * Get Signing Key
     */
    getSigningKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling getSigningKey.');
            }
            if (requestParameters.signingKeySid === null || requestParameters.signingKeySid === undefined) {
                throw new runtime.RequiredError('signingKeySid', 'Required parameter requestParameters.signingKeySid was null or undefined when calling getSigningKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}/signing-keys/{signing_key_sid}`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))).replace(`{${"signing_key_sid"}}`, encodeURIComponent(String(requestParameters.signingKeySid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetSigningKeyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Retrieve a signing key by id, for this webhook
     * Get Signing Key
     */
    getSigningKey(webhookSid, signingKeySid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSigningKeyRaw({ webhookSid: webhookSid, signingKeySid: signingKeySid });
            return yield response.value();
        });
    }
    /**
     * Retrieve a webhook by id
     * Get Webhook
     */
    getWebhookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling getWebhook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiGetWebhookResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Retrieve a webhook by id
     * Get Webhook
     */
    getWebhook(webhookSid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getWebhookRaw({ webhookSid: webhookSid });
            return yield response.value();
        });
    }
    /**
     * Get a list of all signing keys for this webhook
     * List Signing Keys
     */
    listSigningKeysRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling listSigningKeys.');
            }
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.expired !== undefined) {
                queryParameters['expired'] = requestParameters.expired;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}/signing-keys`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListSigningKeysResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a list of all signing keys for this webhook
     * List Signing Keys
     */
    listSigningKeys(webhookSid, pageSize, pageToken, sort, expired) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listSigningKeysRaw({ webhookSid: webhookSid, pageSize: pageSize, pageToken: pageToken, sort: sort, expired: expired });
            return yield response.value();
        });
    }
    /**
     * Get a list of all webhooks
     * List Webhooks
     */
    listWebhooksRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageSize !== undefined) {
                queryParameters['page_size'] = requestParameters.pageSize;
            }
            if (requestParameters.pageToken !== undefined) {
                queryParameters['page_token'] = requestParameters.pageToken;
            }
            if (requestParameters.sort !== undefined) {
                queryParameters['sort'] = requestParameters.sort;
            }
            if (requestParameters.companySid !== undefined) {
                queryParameters['company_sid'] = requestParameters.companySid;
            }
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiListWebhooksResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Get a list of all webhooks
     * List Webhooks
     */
    listWebhooks(pageSize, pageToken, sort, companySid) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listWebhooksRaw({ pageSize: pageSize, pageToken: pageToken, sort: sort, companySid: companySid });
            return yield response.value();
        });
    }
    /**
     * Incoming Twilio Room events, which tell us when Rooms have been created, ended, etc.
     * Twilio Room Event Ingress
     */
    roomEventIngressRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.roomId === null || requestParameters.roomId === undefined) {
                throw new runtime.RequiredError('roomId', 'Required parameter requestParameters.roomId was null or undefined when calling roomEventIngress.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/rooms/{roomId}`.replace(`{${"roomId"}}`, encodeURIComponent(String(requestParameters.roomId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming Twilio Room events, which tell us when Rooms have been created, ended, etc.
     * Twilio Room Event Ingress
     */
    roomEventIngress(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.roomEventIngressRaw({ roomId: roomId });
        });
    }
    /**
     * Incoming Twilio SMS events, which provide delivery status of text messages
     * Twilio SMS Event Ingress
     */
    smsEventIngressRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/sms`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming Twilio SMS events, which provide delivery status of text messages
     * Twilio SMS Event Ingress
     */
    smsEventIngress() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.smsEventIngressRaw();
        });
    }
    /**
     * Incoming Twilio Sync events, informing us when things are added, updated, or deleted
     * Twilio Sync Ingress
     */
    syncIngressRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/sync`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming Twilio Sync events, informing us when things are added, updated, or deleted
     * Twilio Sync Ingress
     */
    syncIngress() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.syncIngressRaw();
        });
    }
    /**
     * Incoming Telnyx SMS events, which provide delivery status of text messages
     * Telnyx SMS Event Ingress
     */
    telnyxSmsEventIngressRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/sms/telnyx`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming Telnyx SMS events, which provide delivery status of text messages
     * Telnyx SMS Event Ingress
     */
    telnyxSmsEventIngress() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.telnyxSmsEventIngressRaw();
        });
    }
    /**
     * Send a test event to this webhook
     * Test Webhook
     */
    testWebhookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling testWebhook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}/~test`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiTestWebhookRequestToJSON)(requestParameters.streemApiTestWebhookRequest),
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Send a test event to this webhook
     * Test Webhook
     */
    testWebhook(webhookSid, streemApiTestWebhookRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.testWebhookRaw({ webhookSid: webhookSid, streemApiTestWebhookRequest: streemApiTestWebhookRequest });
        });
    }
    /**
     * Incoming responses for various Typeform surveys
     * Typeform Response Ingress
     */
    typeformResponseIngressRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/typeform/response`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Incoming responses for various Typeform surveys
     * Typeform Response Ingress
     */
    typeformResponseIngress(body) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.typeformResponseIngressRaw({ body: body });
        });
    }
    /**
     * Update the details of a webhook signing key
     * Update Signing Key
     */
    updateSigningKeyRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling updateSigningKey.');
            }
            if (requestParameters.signingKeySid === null || requestParameters.signingKeySid === undefined) {
                throw new runtime.RequiredError('signingKeySid', 'Required parameter requestParameters.signingKeySid was null or undefined when calling updateSigningKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}/signing-keys/{signing_key_sid}`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))).replace(`{${"signing_key_sid"}}`, encodeURIComponent(String(requestParameters.signingKeySid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateSigningKeyRequestToJSON)(requestParameters.streemApiUpdateSigningKeyRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateSigningKeyResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update the details of a webhook signing key
     * Update Signing Key
     */
    updateSigningKey(webhookSid, signingKeySid, streemApiUpdateSigningKeyRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSigningKeyRaw({ webhookSid: webhookSid, signingKeySid: signingKeySid, streemApiUpdateSigningKeyRequest: streemApiUpdateSigningKeyRequest });
            return yield response.value();
        });
    }
    /**
     * Update the details of a webhook
     * Update Webhook
     */
    updateWebhookRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.webhookSid === null || requestParameters.webhookSid === undefined) {
                throw new runtime.RequiredError('webhookSid', 'Required parameter requestParameters.webhookSid was null or undefined when calling updateWebhook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/v1/webhooks/{webhook_sid}`.replace(`{${"webhook_sid"}}`, encodeURIComponent(String(requestParameters.webhookSid))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiUpdateWebhookRequestToJSON)(requestParameters.streemApiUpdateWebhookRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.StreemApiUpdateWebhookResponseFromJSON)(jsonValue));
        });
    }
    /**
     * Update the details of a webhook
     * Update Webhook
     */
    updateWebhook(webhookSid, streemApiUpdateWebhookRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateWebhookRaw({ webhookSid: webhookSid, streemApiUpdateWebhookRequest: streemApiUpdateWebhookRequest });
            return yield response.value();
        });
    }
    /**
     * Incoming Streem Wall events, informing us when things are added, updated, or deleted
     * Streem Wall Ingress
     */
    wallIngressRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
                headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearer-auth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/webhooks/wall`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, models_1.StreemApiWallIngressRequestToJSON)(requestParameters.streemApiWallIngressRequest),
            });
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Incoming Streem Wall events, informing us when things are added, updated, or deleted
     * Streem Wall Ingress
     */
    wallIngress(streemApiWallIngressRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.wallIngressRaw({ streemApiWallIngressRequest: streemApiWallIngressRequest });
            return yield response.value();
        });
    }
}
exports.WebhooksApi = WebhooksApi;
//# sourceMappingURL=WebhooksApi.js.map